export const phoneMask = (value: string): string => {
  return value
    ?.replace(/\D+/g, '')
    ?.replace(/(\d)/, '($1')
    ?.replace(/(\()(\d{2})/, '$1$2')
    ?.replace(/(\()(\d{2})(\d)/, '$1$2) $3')
    ?.replace(/(\))(\d{1,5})/, '$1 $2')
    ?.replace(/(\d{5})(\d{1,4})/, '$1-$2')
    ?.replace(/(-\d{4})\d+?$/, '$1')
}

export const removeSpecials = (value?: string): string => {
  return value?.replace(/[^\d]/g, '') || ''
}

export const phoneRegex =
  /^$|(?:\()?[0-9]{2}(?:\)?)\s?[0-9]{4,5}(?:-)?[0-9]{4}$/
